import { InfoOutlineIcon, SearchIcon } from '@chakra-ui/icons';
import {
  Box,
  Heading,
  HStack,
  Icon,
  Radio,
  RadioGroup,
  Tooltip,
} from '@chakra-ui/react';
import { TextInput, useTabStorage } from '@laxmimanogna/code-quick-components';
import React, { useContext, useState, useEffect } from 'react';
import AppColors from '../../constants/AppColors';
import { FONT_FAMILY } from '../../constants/Theme';
import { withMultiProviders } from '../../hoc/withProvider';
import useCQMediaQuery from '../../hooks/useCQMediaQuery';
import MyChartProvider, {
  MyChartContext,
} from '../../providers/MyChartProvider';
import AllCharts from './components/tables/AllCharts';
import ArchivedCharts from './components/tables/ArchivedCharts';
import RebuttedCharts from './components/tables/RebuttedCharts';
import AuditSheetProvider, { AuditSheetContext } from '../../providers/AuditSheetProvider';

const MyChartsContainer = props => {
  const myChartsTab = [
    {
      title: 'ALL',
      header: 'Audit Uploads',
      component: AllCharts,
    },
    {
      title: 'ARCHIVED',
      header: 'Archived',
      component: ArchivedCharts,
    },
    {
      title: 'REBUTTAL',
      header: 'Rebuttal',
      component: RebuttedCharts,
    },
  ];
  const myChartContext = useContext(MyChartContext);
  const auditSheetContext = useContext(AuditSheetContext);
  const { handleApplyFilter, filterParams, getAllCharts, getArchivedCharts } =
    myChartContext;

  const tabStorage = useTabStorage();
  const [selectedTab, setSelectedTab] = useState(tabStorage.getTab() || 0);
  const [onSearchText, setSearchText] = useState('');

  useEffect(() => {tabStorage.setTab(selectedTab)}, [selectedTab]);

  const marginHorizontal = useCQMediaQuery({
    lg: '12%',
    md: '6%',
    sm: '2%',
  });

  const onSearchAction = () => {
    handleApplyFilter({ ...filterParams, searchText: onSearchText });
  };

  const onFilterChange = e => {
    if (e) {
      getAllCharts.setParams({ page: 1 });
      getArchivedCharts.setParams({ page: 1 });
      setSearchText(e.target.value);
    } else {
      setSearchText('');
    }
  };

  const onOpenNotes = (obj, batchId, tabType = undefined) => {
    if (obj && Object.keys(obj).length) {
      if (obj.all) {
        delete auditSheetContext.commentFilters.sheet_name
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          page: 1,
          tabType: tabType
        })
      } else if (obj.current) {
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          sheet_name: "Sheet1",
          page: 1,
          tabType: tabType
        })
      }
    } else {
      auditSheetContext.setCommentFilters({
        ...auditSheetContext.commentFilters,
        batchId,
        sheet_name: "Sheet1",
        reverse: true,
        page: 1,
        tabType: tabType
      })
    }

  }

  return (
    <>
      <Box mx={marginHorizontal}>
        <HStack spacing={2} ><Heading my={5} as="h5" fontSize="24px">
          My Charts
        </Heading>
          <Tooltip p={3} bg="whiteAlpha.900"
            color="black"
            borderRadius="md"
            border="1px solid #43dde0" label={
              <Box>
                <>
                  <p>
                    <b>My Charts</b> tab displays only the charts that you have personally uploaded. This helps you manage and review your individual contributions separately.
                  </p>
                </>
              </Box>
            } placement="top-end">
            <Icon as={InfoOutlineIcon} w={4} h={4} cursor="pointer" _hover={{ color: AppColors.secondary, transition: 'color 0.3s ease-in-out' }} color={AppColors.primary} />
          </Tooltip></HStack>
        <Box
          shadow={'md'}
          bg="white"
          p={4}
          w="100%"
          style={{ borderRadius: '12px' }}
        >
          <HStack w={'100%'} justifyContent={'space-between'} pb={3} borderBottom="1px solid" borderColor="gray.100">
            <RadioGroup
              value={String(selectedTab)}
              onChange={v => setSelectedTab(Number(v))}
              fontFamily={FONT_FAMILY.baiJamurjee}
            >
              <HStack spacing={6} px={4}>
                {myChartsTab.map((aa, index) => (
                  <Radio
                    key={`my-charts-radio-${index}`}
                    value={String(index)}
                    colorScheme="cyan"
                    fontFamily={FONT_FAMILY.baiJamurjee}
                    fontWeight={selectedTab === index ? 'bold' : 'normal'}
                    color={selectedTab === index ? AppColors.secondary : 'black'}
                  >
                    {aa.title}
                  </Radio>
                ))}
              </HStack>
            </RadioGroup>
            <Box>
              <TextInput
                borderRadius={'md'}
                value={onSearchText}
                onChange={e => onFilterChange(e)}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    onSearchAction();
                  }
                }}
                mb="2"
                rightIconProps={{ zIndex: 0 }}
                placeholder="Search"
                rightIcon={
                  <SearchIcon
                    onClick={onSearchAction}
                    color={AppColors.gray}
                  />
                }
              />
            </Box>
          </HStack>

          <Box pt={3}>
            {myChartsTab.map((aa, index) => (
              selectedTab === index && (
                <aa.component key={`my-charts-panel-${index}`} onOpenNotes={onOpenNotes} />
              )
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default withMultiProviders([MyChartProvider, AuditSheetProvider], MyChartsContainer);
